import { render } from "./CotizacionComponent.vue?vue&type=template&id=95191e26"
import script from "./CotizacionComponent.vue?vue&type=script&lang=js"
export * from "./CotizacionComponent.vue?vue&type=script&lang=js"

import "./CotizacionComponent.vue?vue&type=style&index=0&id=95191e26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__